import { VdirHandler } from 'owa-router';
import { updateModuleForVdirChange } from './updateModuleForVdirChange';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function getVdirHandler(appName: string): VdirHandler | undefined {
    return isFeatureEnabled('fwk-module-switch')
        ? {
              setModuleForVdir: updateModuleForVdirChange,
              appName: appName,
          }
        : undefined;
}
